import styled from "styled-components";

export const StylesRadioItem = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;

  .radio-item {
    margin-bottom: 0;
  }

  .ant-radio-group {
    padding-left: 16px;
    height: 62px;
    display: flex;
    align-items: end;
  }
`;

export const StyledDecimalPlaceInputItem = styled.div`
  .ant-input-number {
    width: 100%;
  }
`;
